import { useState } from "react";
import { getSelectedAdvisor } from "web_myplann/Advisor/Utils/getSelectedAdvisor";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const useAdvisorSelection = (
	advisors: AgentAssignedListItemResponseDTO[],
) => {
	const [selectedId, setSelectedId] = useState<string>();

	return {
		selected: getSelectedAdvisor(advisors, selectedId),
		selectAdvisor: (uid: string) => setSelectedId(uid),
		clearSelection: () => setSelectedId(undefined),
	};
};
